import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";

import styles from "./index.module.scss";
import Maybe from "components/Maybe";

interface IProps {
	login?: boolean;
	register?: boolean;
	forget?: boolean;
}

const ExternalLinks: React.FC<IProps> = props => {
	return (
		<Row gutter={48} className={styles["external-links"]}>
			<Maybe condition={props.forget}>
				<Col span={12}>
					<Link to="/auth/forget">فراموشی رمز عبور</Link>
				</Col>
			</Maybe>
			<Maybe condition={props.login}>
				<Col span={24}>
					<Link to="/auth/login">ورود</Link>
				</Col>
			</Maybe>
			<Maybe condition={props.register}>
				<Col span={24}>
					<br/>
					<Link to="/auth/register">ثبت نام</Link>
				</Col>
			</Maybe>
		</Row>
	);
};

ExternalLinks.defaultProps = {
	login: false,
	register: false,
	forget: false,
};

export default ExternalLinks;
